import React from 'react';
import PropTypes from 'prop-types';

const ProfileBanner = ({
  children,
  className,
  img,
  userType,
  ...props
}) => {
  // set banner color with user type
  const coverImageClassName = `profile-banner cover ${{
    2: 'buyer-color',
    4: 'seller-color',
  }[userType] || 'distributor-color'}`;
  const imageUrl = img || '/assets/images/profile-banner.jpg';

  return (
    <div className={`${coverImageClassName} ${className}`} {...props}>
      <img
        className="cover-image"
        alt=""
        src={imageUrl}
      />
      {children}
    </div>
  );
};

ProfileBanner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  img: PropTypes.string,
  userType: PropTypes.number,
};

ProfileBanner.defaultProps = {
  children: null,
  className: '',
  img: '',
  userType: 0,
};

export default ProfileBanner;
